module.exports = {"data":{"site":{"siteMetadata":{"title":"Melissa O'Hearn","description":"Melissa O'Hearn is a product and fashion photographer in Seattle, Washington."}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 92
// module chunks = 60335399758886 114276838955818